import React from 'react'
import InventoryList from '../../Component/InventoryList'
import { Box } from '@mui/material'

const Inventory = () => {
    return (
        <Box padding={"25px"}>
            <InventoryList />
        </Box>
    )
}

export default Inventory